module.exports = __webpack_public_path__ + "img/totquestions.d384fa91.svg";